import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useAddBasicBoardModal } from './context/AddBasicBoardModalContext';
import AddBasicBoardModalHeader from './components/AddBasicBoardModalHeader';
import AddBasicBoardModalBody from './components/AddBasicBoardModalBody';
import AddBasicBoardModalFooter from './components/AddBasicBoardModalFooter';

import '../Modals.scss';

type AddBasicBoardModalProps = {
  size?: string;
};

const AddBasicBoardModal: FC<AddBasicBoardModalProps> = ({
  ...props
}: AddBasicBoardModalProps) => {
  const { data } = useAddBasicBoardModal();

  return (
    <>
      <AddBasicBoardModalHeader />
      <AddBasicBoardModalBody />
      <AddBasicBoardModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default AddBasicBoardModal;
